var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"air__utils__heading"},[_c('h5',[_vm._v("Dashboard")])]),_c('div',{staticClass:"row"})])}]

export { render, staticRenderFns }